import { authSelectors } from 'reducers/auth'
import { useSelector } from 'react-redux'

export const useAuthToken = () => useSelector(authSelectors.token)
